import { DocsGuide } from "@/types/docs-guides";

import body from "./body.mdx";

const gettingStarted: DocsGuide = {
  title: "Getting Started: Hosting the MML Starter Project",
  description: "Learn how to deploy the Starter Project.",
  body,
  linkList: ["CodeSandbox", "Glitch", "Digital Ocean", "Heroku", "Railway", "AWS Lightsail"],
};

export default gettingStarted;
